import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';
import debounce from 'lodash.debounce';

import { connect } from 'react-redux';

import changeScreen from 'actions/router';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper,
  Labels
} from 'containers';

import { DisplayIcon, ProgressBarIcon } from 'components';
import {
  DisplayButton,
  ConfirmButton,
  CancelButton
} from 'components/buttons';

import styles from './Regeneration.scss';

class Regeneration extends Component {
  constructor(props) {
    super(props);

    this.prevScreen = 'service/dpf-soot';
    this.initialDelay = 5000;
    this.completeDelay = 3000;

    this.state = {
      currentStage: 'initial',
      buttonConfig: {
        start: {
          left: {
            onClick: this.beginRegen
          },
          right: {
            destination: this.prevScreen
          }
        },
        active: {
          center: {
            onClick: this.cancelRegen
          }
        }
      }
    };
  }

  componentDidMount() {
    debounce(() => this.changeStage('start'), this.initialDelay)();
  }

  changeStage = newStage => this.setState({ currentStage: newStage });

  beginRegen = () => {
    this.changeStage('active');

    this.regenerationInProgress = debounce(
      () => {
        this.changeStage('complete');

        debounce(() => this.props.changeScreen('main'), this.completeDelay)();
      },
      this.initialDelay
    );

    this.regenerationInProgress();
  }

  cancelRegen = () => {
    this.regenerationInProgress.cancel();

    this.changeStage('interrupted');

    debounce(() => this.props.changeScreen(this.prevScreen), this.completeDelay)();
  }

  showContent = (icons) => {
    const { currentStage } = this.state;
    let output = icons.map(icon => (
      <DisplayIcon
        key={uuidv4()}
        src={icon}
      />
    ));

    if (currentStage === 'active') {
      output = [
        <DisplayIcon key={uuidv4()} src={icons[0]} />,
        <ProgressBarIcon key={uuidv4()} />,
        <DisplayIcon key={uuidv4()} src={icons[1]} />
      ];
    }

    return output;
  }

  showDisplayButtons = (stage) => {
    let displayButtons = [
      <DisplayButton key={uuidv4()} src="icon-xm-turtle" />,
      <DisplayButton key={uuidv4()} src="icon-xm-leaf" />,
      <DisplayButton key={uuidv4()} src="icon-xm-rabbit" />
    ];

    if (stage === 'start') {
      displayButtons = [
        <ConfirmButton key={uuidv4()} />,
        <CancelButton key={uuidv4()} />
      ];
    } else if (stage === 'active') {
      displayButtons = <DisplayButton text="X" />;
    }

    return displayButtons;
  };

  render() {
    const { currentStage, buttonConfig } = this.state;
    const { content } = this.props;
    const config = buttonConfig[currentStage] || {};

    let output = <div />;

    if (Object.keys(content).length > 0) {
      const { data, icons } = content[currentStage];

      output = [
        <Display key="display">
          <Header buttonContainer>
            <DisplayButton src="icon-xm-settings" selected />
            <DisplayButton src="icon-xm-p" selected />
            <DisplayButton src="icon-xm-n" selected />
            <DisplayButton src="icon-xm-person" selected />
          </Header>
          <Content>
            <div
              className={`
                ${styles.contentWrapper}
                ${currentStage === 'complete' ? styles.centerWrapper : ''}
              `}
            >
              <Labels values={data} />
              {icons &&
                <div
                  className={`
                    ${styles.iconWrapper}
                    ${currentStage === 'start' ? styles.regenStart : ''}
                    ${currentStage === 'active' ? styles.regenActive : ''}
                  `}
                >
                  {this.showContent(icons)}
                </div>}
            </div>
          </Content>
          <Footer align={currentStage === 'active' ? 'center' : ''}>
            {this.showDisplayButtons(currentStage)}
          </Footer>
        </Display>,
        <HardwareButtonWrapper key="buttons" config={config} />
      ];
    }

    return output;
  }
}

Regeneration.propTypes = {
  content: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.object),
    icons: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  changeScreen: PropTypes.func.isRequired
};

export default connect(({ regeneration }) => ({
  content: regeneration
}), {
  changeScreen
})(Regeneration);



// WEBPACK FOOTER //
// ./src/screens/Diesel/Regeneration/Regeneration.js